import type { InstallationDraft, InstallationPreferencesV2 } from 'types/installationPresentation';
import { APPROVED_CHECKOUT_TITLE_PRESETS, getApprovedCheckoutTitlePreset } from 'ui.shipaid.com/renderers/checkout-plus-legacy';
import { upgradeInstallationPreferences } from './installationPresentation';

export const CHECKOUT_TITLE_REVIEW_MESSAGE = 'Choose approved checkout wording before saving. For custom wording, book a call with our team.';

const approvedTitle = (title: unknown): boolean => Boolean(getApprovedCheckoutTitlePreset(title));

export const hasApprovedCheckoutTitles = (draft: InstallationDraft): boolean =>
  draft.schemaVersion === 1 || (approvedTitle(draft.appearance.copy.title) &&
    Object.values(draft.appearance.localeOverrides).every(copy => copy === null || approvedTitle(copy.title)));

export function withApprovedCheckoutTitle(draft: InstallationDraft, title: unknown): InstallationPreferencesV2 | null {
  const preset = getApprovedCheckoutTitlePreset(title);
  if (!preset) return null;
  const next = draft.schemaVersion === 2 ? draft : upgradeInstallationPreferences(draft);
  if (!next) return null;
  const localeOverrides = { ...next.appearance.localeOverrides };
  for (const locale of Object.keys(localeOverrides) as Array<keyof typeof localeOverrides>) {
    const copy = localeOverrides[locale];
    // Explicit label selection applies across locales; keep all non-title translations.
    if (copy) localeOverrides[locale] = { ...copy, title: null };
  }
  return { ...next, appearance: { ...next.appearance,
    copy: { ...next.appearance.copy, title: preset.title === APPROVED_CHECKOUT_TITLE_PRESETS[0].title ? null : preset.title }, localeOverrides } };
}
